module.exports = __webpack_public_path__ + "static/media/  (136).86818f5c.jpg";